import React, { useEffect, useRef, useState, forwardRef } from "react";
import PageError from "./PageError.js";
import { MDBBtn, MDBCard, MDBCardBody, MDBCheckbox, MDBCol, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow } from "mdb-react-ui-kit";
import { getRevenueReports, getRenewalReports, getTransactionByTIds, getStaffInfo, getGymPlansList } from "../services/apiServices.js";
import DatePicker from 'react-datepicker';
import calImg from "./../components/images/calendar.svg";
import ExcelExportButton from "../components/exportToExcel.js";
import Loader from "../components/Loader.js";
import moment from 'moment-timezone';
import { format } from 'date-fns';
import { LineReportChart, RenewPredictionChart } from "../components/renewalGraph.js";
import { formatDate } from '../utils/DateFormat';
import { useAnalytics } from "../hooks/useAnalytics.js";

function RenewPrediction() {
    const { trackButtonClick } = useAnalytics();
    const [DayFilter1, setDayFilter1] = useState("3");
    const [breakdownApplied, setBreakdownApplied] = useState(false);
    const [memberData, setmemberData] = useState([])
    const [revenueData, setRevenueData] = useState([])
    const [apiError, setApiError] = useState(false);
    const [DayFilter, setDayFilter] = useState("5");
    const [rangeFilter, setRangeFilter] = useState("");
    const [plans, setPlans] = useState([])
    const [loading, setLoading] = useState(false)
    const [graphCheck, setGraphCheck] = useState(false)
    const [basicData, setBasicData] = useState({
        columns: [
            { label: 'Date', field: 'date' },
            { label: 'High chances (100-80%)', field: 'High chances' },
            { label: 'Medium chances (79-50%)', field: 'Medium chances' },
            { label: 'Low chances (<50%)', field: 'Low chances' },
            { label: 'New Revenue', field: 'New Revenue' },
            { label: 'Renew Revenue', field: 'Renew Revenue' },
            { label: 'Actual Revenue', field: 'Actual Revenue' },
        ],
        rows: [],
    });

    const [card, setCard] = useState({
        new: 0,
        renew: 0,
    })
    const searchRef = useRef();
    const [customdate, setcustomdate] = useState(DayFilter === "6");
    const [customRange, setCustomRange] = useState(rangeFilter === "5")
    const today = new Date();
    const currentTime = new Date();
    const startOfToday = new Date(currentTime);
    startOfToday.setHours(0, 0, 0, 0);

    const endOfToday = new Date(currentTime);
    endOfToday.setHours(23, 59, 59, 999);

    const yesterday = new Date(currentTime);
    yesterday.setDate(currentTime.getDate() - 1);
    const startOfYesterday = new Date(yesterday);
    startOfYesterday.setHours(0, 0, 0, 0);

    const endOfYesterday = new Date(yesterday);
    endOfYesterday.setHours(23, 59, 59, 999);

    const startOfWeek = new Date(currentTime);
    startOfWeek.setDate(currentTime.getDate() - currentTime.getDay());
    startOfWeek.setHours(12, 0, 0, 0);
    const endOfWeek = new Date(currentTime);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(12, 0, 0, 0);

    const startOfMonth = new Date(currentTime);
    startOfMonth.setDate(1);
    startOfMonth.setHours(0, 0, 0, 0);

    const endOfMonth = new Date(currentTime.getFullYear(), currentTime.getMonth() + 1, 0);
    endOfMonth.setHours(23, 59, 59, 999);

    const startOfYear = new Date(currentTime);
    startOfYear.setMonth(0, 1);
    startOfYear.setHours(0, 0, 0, 0);

    const endOfYear = new Date(currentTime);
    endOfYear.setMonth(11, 31);
    endOfYear.setHours(23, 59, 59, 999);
    today.setHours(23, 59, 0, 0);
    const [dateRange, setDateRange] = useState([startOfYear, endOfYear]);
    const [startDate, endDate] = dateRange;
    const [applyFilterClicked, setApplyFilterClicked] = useState(false)
    const [resetFilterClicked, setResetFilterClicked] = useState(false)

    const [mfilter, setMfilter] = useState({
        tidName: "",
        Ttype: "",
    })
    const bucketRanges = [
        { label: 'High chances', min: 80, max: 100 },
        { label: 'Medium chances', min: 50, max: 79 },
        { label: 'Low chances', min: 0, max: 49 }
    ];
    const [selectedRowData, setSelectedRowData] = useState(null);

    const [range, setRange] = useState({
        from: 0,
        to: 0
    })
    const [basicData2, setBasicData2] = useState({
        columns: [
            { label: 'S.No', field: 'sno' },
            { label: 'Member Name', field: 'memberName' },
            { label: 'Current Plan', field: 'currentplan' },
            { label: 'Expiry Date', field: 'expirydate' },
            { label: 'Renew', field: 'renew' },
            { label: 'Renew chance', field: 'renewchance' },
            { label: 'Summary', field: 'summary' },
        ],
        rows: [],
    })
    const [centredModal, setCentredModal] = useState(false);
    const toggleOpenPlan = () => setCentredModal(!centredModal);
    const [openTogle, setOpenTogle] = useState(false)
    const [memberName, setMemberName] = useState("")
    const CalenderInput = forwardRef(({ value, onClick }, ref) => (
        <>
            <span className="gym-input forminput h-40">
                {value === "" ? "Custom Range" : value}
                &nbsp;
                <img
                    src={calImg}
                    onClick={onClick}
                    ref={ref}
                    alt="custom Range"
                    title="Select Custom Range"
                />
            </span>
        </>
    ));

    const getDates = (obj) => {
        setDateRange(obj);
    };

    const handleApplyAndToggle = () => {
        const sDate = DayFilter === "1" ? startOfToday : (DayFilter === "2" ? startOfYesterday : (DayFilter === "3" ? startOfWeek : (DayFilter === "4" ? startOfMonth : (DayFilter === "5" ? startOfYear : (DayFilter === "6" ? startDate : null)))))
        const eDate = DayFilter === "1" ? endOfToday : (DayFilter === "2" ? endOfYesterday : (DayFilter === "3" ? endOfWeek : (DayFilter === "4" ? endOfMonth : (DayFilter === "5" ? endOfYear : (DayFilter === "6" ? endDate : null)))))
        if (sDate !== null && eDate !== null) {
            setDateRange([sDate, eDate])
        } else {
            setDateRange([])
        }

        // setBasicData(prevData => ({
        //     ...prevData,
        //     columns: [],
        // }));

        setBreakdownApplied(true);
        setApplyFilterClicked(true)
    }

    const handleResetAndToggle = () => {
        setDayFilter("5")
        setDateRange([startOfYear, endOfYear])
        setMfilter({
            tidName: "",
            Ttype: "",
        })
        setDayFilter1("3")
        setBreakdownApplied(false);
        setResetFilterClicked(true)
        setCustomRange(false)
        setRange({
            from: 0,
            to: 0
        })
        setRangeFilter("")
        setResetFilterClicked(true)

        // setBasicData({
        //     columns: [
        //         { label: 'Date', field: 'date' },
        //         { label: 'High chances (100-80%)', field: 'High chances' },
        //         { label: 'Medium chances (79-50%)', field: 'Medium chances' },
        //         { label: 'Low chances (<50%)', field: 'Low chances' },
        //         { label: 'New Revenue', field: 'New Revenue' },
        //         { label: 'Renew Revenue', field: 'Renew Revenue' },
        //         { label: 'Actual Revenue', field: 'Actual Revenue' },
        //     ],
        //     rows: [],
        // });
    }

    let filter = {}

    async function fetchData() {
        setLoading(true)
        let startOfDate = startDate
        let endOfDate = endDate
        let Dateobj = {}
        filter.name = mfilter.tidName
        filter.Ttype = mfilter.Ttype

        if ((startOfDate && endOfDate)) {
            const startDatef = new Date(startOfDate)
            startDatef.setHours(0, 0, 0, 0)
            const utcstartDate = startDatef.toISOString();
            let lastoftheday = new Date(endOfDate);
            lastoftheday.setHours(23, 59, 59, 999);
            const utcEndDate = lastoftheday.toISOString();
            Dateobj = {
                startDate: utcstartDate,
                endDate: utcEndDate,
            }
        }
        filter.dateobj = Dateobj
        filter.breaktype = DayFilter1
        const response = await getRenewalReports(
            JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, filter
        );

        if (!response) {
            return;
        }
        if (response === "false") {
            setApiError(true)
            return;
        }

        const record = await response.json();
        if (!record) {
            return;
        }

        setLoading(true)
        setmemberData(record);
        setApplyFilterClicked(false)
        setResetFilterClicked(false)
    }

    async function fetchRevenueData() {
        setLoading(true)
        console.log("inside Revenue data");

        let startOfDate = startDate
        let endOfDate = endDate
        let Dateobj = {}
        filter.name = mfilter.tidName
        filter.Ttype = mfilter.Ttype

        if ((startOfDate && endOfDate)) {
            const startDatef = new Date(startOfDate)
            startDatef.setHours(0, 0, 0, 0)
            const utcstartDate = startDatef.toISOString();
            let lastoftheday = new Date(endOfDate);
            lastoftheday.setHours(23, 59, 59, 999);
            const utcEndDate = lastoftheday.toISOString();
            Dateobj = {
                startDate: utcstartDate,
                endDate: utcEndDate,

            }
        }
        filter.dateobj = Dateobj
        filter.breaktype = DayFilter1
        console.log(filter, 'filter');

        const response = await getRevenueReports(
            JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, filter
        );

        // console.log(response);
        if (!response) {
            return;
        }
        if (response === "false") {
            setApiError(true)
            return;
        }

        const record = await response.json();
        if (!record) {
            return;
        }
        console.log(record, '8888888888888888');
        const sortedRecord = record.sort((a, b) => new Date(b._id) - new Date(a._id));

        // setLoading(true)
        setRevenueData(sortedRecord);

    }

    console.log(revenueData, 'memberData');

    async function fetchPlans() {
        if (localStorage.getItem("loggedUserInfo")) {
            const response = await getGymPlansList(
                JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
            );
            if (!response) {
                return;
            }
            if (response === "false") {
                // setApiError(true)
            } else {
                const tempData = await response.json();

                let expandedPlans = [];
                tempData.forEach(plan => {
                    plan.type = "plan";
                    expandedPlans.push(plan);

                    if (plan.subplans && plan.subplans.length > 0) {
                        plan.subplans.forEach(sub => {
                            sub.type = "plan";
                            expandedPlans.push(sub);
                        });
                    }
                });


                setPlans(expandedPlans);
            }
        }
    }

    useEffect(() => {
        if (localStorage.getItem("loggedUserInfo")) {
            const fetchAllData = async () => {
                await fetchRevenueData();
                await fetchPlans();
                await fetchData();
            };
            fetchAllData();

        }
    }, [applyFilterClicked, resetFilterClicked])

    useEffect(() => {
        setcustomdate(DayFilter === "6" ? true : false);
    }, [DayFilter]);

    useEffect(() => {
        setCustomRange(rangeFilter === "5" ? true : false);
    }, [rangeFilter]);

    const generateInvoice = (price, discount = 0, tax = []) => {
        if (!price) return 0;
        const hasIncluded = tax.length > 0 ? tax.some(taxItem => taxItem.TaxCheck === "Included") : true;
        let planPrice = hasIncluded ? parseFloat(price / (1 + ((tax && tax.length > 0) ? (tax.reduce((acc, obj) => acc + (obj.percentage ? (parseFloat(obj.percentage) / 100) : 0), 0)) : 0))).toFixed(2) : price
        const totaltaxpercentage = (tax && tax.length > 0)
            ? tax.reduce((acc, obj) => acc + (obj.percentage ? parseFloat(obj.percentage) : 0), 0)
            : 0;

        const discountedPrice = parseFloat(planPrice) - parseFloat(discount);

        const totalTaxAmount = parseFloat(discountedPrice) * (totaltaxpercentage / 100);
        const finalPrice = discountedPrice + parseFloat(totalTaxAmount);

        if (isNaN(finalPrice)) {
            return 0;
        }
        return Math.round(finalPrice);
    };

    const [selectedData, setSelectedData] = useState([])
    const [seletedType, setSelectedType] = useState("")
    const bucketMap = (percentage) => {
        if (percentage >= 80) return 'High chances';
        if (percentage >= 50) return 'Medium chances';
        return 'Low chances';
    };

    const handleCellClick = (date, columnName, type) => {
        setSelectedType(type)
        if (type == "Prediction") {
            let min, max;

            switch (columnName) {
                case 'High chances':
                    min = 80;
                    max = 100;
                    break;
                case 'Medium chances':
                    min = 50;
                    max = 79;
                    break;
                case 'Low chances':
                    min = 0;
                    max = 49;
                    break;
                default:
                    min = 0;
                    max = 100;
            }

            const filteredMembers = memberData.filter(item => {
                const itemDate = new Date(item.date);
                const month = itemDate.toLocaleString('en-US', { month: 'short' });
                const year = itemDate.getFullYear();

                const dateKey = `${month}-${year}`;
                // const itemDate = new Date(item.date).toISOString().split('T')[0];
                return dateKey === date && item.percentage >= min && item.percentage <= max;
            });

            setSelectedData(filteredMembers);
            setOpenTogle(true);
        } else {
            const data = revenueData.find(item => item.datelabel === date);
            if (!data) {
                setSelectedData([])
                setOpenTogle(true);
                return
            }
            console.log(data, columnName);
            setSelectedRowData(data)
            let ids = [];

            if (columnName === "new" && data.new && data.new.transinfo) {
                ids = data.new.transinfo.map(item => item.id);
            } else if (columnName === "renew" && data.renew && data.renew.transinfo) {
                ids = data.renew.transinfo.map(item => item.id);
            } else {
                const newIds = data.new && data.new.transinfo ? data.new.transinfo.map(item => item.id) : [];
                const renewIds = data.renew && data.renew.transinfo ? data.renew.transinfo.map(item => item.id) : [];
                ids = [...newIds, ...renewIds];
            }

            console.log("Ids to send:", ids);

            fetchTransData(ids);
        }



    };

    const fetchTransData = async (transid) => {
        const update = {
            tids: transid
        }
        const transResponse = await getTransactionByTIds(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, update)
        if (!transResponse) {
            return;
        }
        if (transResponse === "false") {
            setApiError(true)
            return;
        }

        const record = await transResponse.json();
        console.log(record);

        if (!record) {
            return;
        }
        setOpenTogle(true)
        setSelectedData(record)
    }

    useEffect(() => {
        if (memberData && memberData.length > 0) {
            const groupedData = {};

            memberData.forEach(item => {
                // const date = new Date(item.date);
                // const month = date.toLocaleString('default', { month: 'short' });
                // const year = date.getFullYear();

                // const dateKey = `${month}-${year}`;
                const dateKey = moment(item.date).format("MMM-YYYY");
                // new Date(item.date).toISOString().split('T')[0];
                const bucket = bucketMap(item.percentage);

                if (!item.trans || !item.trans.payment) return;

                const planPrice = item.trans.payment.itemprice ?? 0;
                const taxamount = item.trans.payment.taxamounts ?? 0;
                const discount = item.trans.payment.discount ?? 0;
                const invoiceAmount = generateInvoice(planPrice, discount, taxamount);

                if (!groupedData[dateKey]) {
                    groupedData[dateKey] = {
                        date: dateKey,
                        'High chances': 0,
                        'Medium chances': 0,
                        'Low chances': 0
                    };
                }

                groupedData[dateKey][bucket] += invoiceAmount;
            });

            const popupRow = Object.entries(groupedData).map(([date, row]) => {
                const newRow = { date };


                const currentRevenue = revenueData.find(item => item.datelabel === date);
                ['High chances', 'Medium chances', 'Low chances'].forEach(chanceLevel => {
                    newRow[chanceLevel] = (
                        <span
                            onClick={() => handleCellClick(date, chanceLevel, 'Prediction')}
                            className="button-link link-color"
                        >
                            {"₹" + (row[chanceLevel] || 0).toLocaleString('en-IN')}
                        </span>
                    );
                });

                // Add revenue columns if matching data is found
                if (currentRevenue) {
                    const newAmount = currentRevenue.new?.amount || 0;
                    const renewAmount = currentRevenue.renew?.amount || 0;
                    const totalAmount = newAmount + renewAmount;

                    newRow['New Revenue'] = <span
                        className="button-link link-color"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCellClick(date, "new", "revenue");
                        }}
                    >
                        {"₹" + newAmount.toLocaleString('en-IN')}
                    </span>


                    newRow['Renew Revenue'] = <span
                        className="button-link link-color"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCellClick(date, "renew", "revenue");
                        }}
                    >
                        {"₹" + renewAmount.toLocaleString('en-IN')}
                    </span>

                    newRow['Actual Revenue'] = <span
                        className="button-link link-color"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCellClick(date, "total", "revenue");
                        }}
                    >
                        {"₹" + totalAmount.toLocaleString('en-IN')}
                    </span>

                } else {
                    newRow['New Revenue'] =
                        <span
                            className="button-link link-color"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCellClick(date, "new", "revenue");
                            }}
                        >
                            {"₹0"}
                        </span>

                    newRow['Renew Revenue'] =
                        <span
                            className="button-link link-color"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCellClick(date, "renew", "revenue");
                            }}
                        >
                            {"₹0"}
                        </span>
                    newRow['Actual Revenue'] =
                        <span
                            className="button-link link-color"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCellClick(date, "total", "revenue");
                            }}
                        >
                            {"₹0"}
                        </span>
                }

                return newRow;
            });

            setBasicData({
                columns: [
                    { label: 'Date', field: 'date' },
                    { label: 'High chances (100-80%)', field: 'High chances' },
                    { label: 'Medium chances (79-50%)', field: 'Medium chances' },
                    { label: 'Low chances (<50%)', field: 'Low chances' },
                    { label: 'New Revenue', field: 'New Revenue' },
                    { label: 'Renew Revenue', field: 'Renew Revenue' },
                    { label: 'Actual Revenue', field: 'Actual Revenue' },
                ],
                rows: popupRow
            });
        } else {
            setBasicData({
                columns: [
                    { label: 'Date', field: 'date' },
                    { label: 'High chances (100-80%)', field: 'High chances' },
                    { label: 'Medium chances (79-50%)', field: 'Medium chances' },
                    { label: 'Low chances (<50%)', field: 'Low chances' },
                    { label: 'New Revenue', field: 'New Revenue' },
                    { label: 'Renew Revenue', field: 'Renew Revenue' },
                    { label: 'Actual Revenue', field: 'Actual Revenue' },
                ],
                rows: [],
            });
        }
        setLoading(false);
    }, [memberData, revenueData]);
    console.log(selectedData, seletedType, 'selectedData');

    useEffect(() => {
        const popupRow = [];


        if (seletedType == "Prediction") {
            if (selectedData && selectedData.length > 0) {
                selectedData.forEach((selectedRowData, index) => {
                    const rarray = [];
                    const planName = plans && plans.length > 0 ? plans.find((item) => item._id == selectedRowData.planid) : {}
                    const tax = selectedRowData?.trans?.payment?.taxamounts || [];
                    const discountValue = selectedRowData?.trans?.payment?.discount ? selectedRowData.trans.payment.discount.amount : 0;

                    rarray.push(index + 1 || "--");
                    rarray.push(selectedRowData?.member?.fname ? selectedRowData.member.fname + " " + selectedRowData.member.lname : "");
                    let membershipName = "--";
                    if (planName?.name) {
                        if (planName.baseplan) {
                            const basePlan = plans.find(p => p._id === planName?.baseplan);
                            membershipName = basePlan
                                ? `${basePlan.name}-${planName.name}`
                                : planName.name;
                        } else {
                            membershipName = planName.name;
                        }
                    }
                    rarray.push(membershipName);

                    rarray.push(
                        <span className="trans-date">
                            {formatDate(selectedRowData.date).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}
                        </span>
                    );
                    rarray.push(
                        "₹" +
                        (generateInvoice(
                            selectedRowData.trans?.payment?.itemprice || 0,
                            discountValue || 0,
                            tax || []
                        )).toLocaleString('en-IN')
                    );
                    rarray.push(selectedRowData.isRenew ? "Yes" : "No");

                    rarray.push(selectedRowData?.percentage ? selectedRowData?.percentage + "%" : "--");
                    rarray.push((selectedRowData?.summary ? selectedRowData?.summary : "--"))

                    popupRow.push(rarray);
                });
            }
            setBasicData2({
                columns: ['S.No', 'Member Name', 'Current Membership', 'Expiry Date', 'Amount', 'Renew', "Renew chance", 'Summary'],
                rows: popupRow
            });
        } else {
            if (selectedData && selectedData.length > 0) {
                selectedData.forEach((selectedRowData) => {
                    const rarray = [];

                    const tax = selectedRowData.payment?.taxamounts || [];
                    const discountValue = selectedRowData.payment?.discount?.amount || 0;
                    const itemPrice = selectedRowData.payment?.itemprice || 0;
                    const balance = selectedRowData.payment?.balance || 0;

                    // Order ID / Token
                    rarray.push(selectedRowData.token || "--");

                    // Member Name
                    const fname = selectedRowData.members?.fname || "";
                    const lname = selectedRowData.members?.lname || "";
                    rarray.push(fname + " " + lname);

                    let membershipName = "--";

                    // 1. Plan check
                    if (selectedRowData.plan?.length > 0 && selectedRowData.plan[0].name) {
                        const planObj = selectedRowData.plan[0];

                        if (planObj.baseplan) {
                            const basePlan = plans.find(p => p._id === planObj.baseplan);
                            membershipName = basePlan
                                ? `${basePlan.name}-${planObj.name}`
                                : planObj.name;
                        } else {
                            membershipName = planObj.name;
                        }

                        // 2. Subplan check
                    } else if (selectedRowData.subplan?.length > 0 && selectedRowData.subplan[0].name) {
                        const subPlanObj = selectedRowData.subplan[0];

                        if (subPlanObj.baseplan) {
                            const basePlan = plans.find(p => p._id === subPlanObj.baseplan);
                            membershipName = basePlan
                                ? `${basePlan.name}-${subPlanObj.name}`
                                : subPlanObj.name;
                        } else {
                            membershipName = subPlanObj.name;
                        }

                        // 3. Addons check
                    } else if (selectedRowData.addons?.length > 0 && selectedRowData.addons[0].name) {
                        membershipName = selectedRowData.addons[0].name;
                    }

                    rarray.push(membershipName);


                    // Date (formatted)
                    rarray.push(
                        <span className="trans-date">
                            {formatDate(selectedRowData.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}
                        </span>
                    );

                    // Price
                    rarray.push("₹" + itemPrice.toLocaleString('en-IN'));

                    // Discount
                    rarray.push("₹" + discountValue.toLocaleString('en-IN'));

                    // Due Amount
                    rarray.push("₹" + balance.toLocaleString('en-IN'));

                    // Total (invoice)
                    const total = generateInvoice(itemPrice, discountValue, tax);
                    rarray.push("₹" + total.toLocaleString('en-IN'));

                    popupRow.push(rarray);
                });

                console.log(popupRow, 'popupRow');
            }
            setBasicData2({
                columns: ['Order Id', 'Member Name', 'Membership', 'Date', 'Price', 'Discount', "Due Amount", 'Total'],
                rows: popupRow
            });
        }



    }, [selectedData]);
    console.log(basicData2, 'basicData2');

    const handleReload = () => {
        window.location.reload();
    }

    const cleanNumericValue = (value) => {
        if (React.isValidElement(value)) {
            value = value.props.children;
        }

        if (typeof value === 'string') {
            const cleanedValue = value.replace(/[₹$,]/g, '');
            const numericValue = Number(cleanedValue);
            return !isNaN(numericValue) ? numericValue : value;
        }

        return value;
    };

    const downloaddata = (tableinfo, title) => {
        let expoinfo = {
            columns: [],
            rows: []
        }
        if (title == "Renew_Prediction") {
            const cleanedRows = tableinfo.rows.map(row => {
                const cleanedRow = [row.date];

                basicData.columns.forEach(col => {
                    if (col.field !== 'date') {
                        cleanedRow.push(cleanNumericValue(row[col.field]));
                    }
                });

                return cleanedRow;
            });

            const exportObj = {
                columns: basicData.columns.map(col => col.label),
                rows: cleanedRows,
            };
            expoinfo = exportObj
        } else {
            expoinfo = tableinfo
        }


        ExcelExportButton(expoinfo, title);
        trackButtonClick("RenewPrediction", "Export_Renew_Prediction", "staff", {});
    };



    return (
        <>
            {apiError ? <PageError handleReload={handleReload} /> :
                <div className="mt-4">
                    <div className=" d-flex flex-wrap w-90 align-items-end">
                        {/* <div className="gym-section w-100-mobile ms-2">
                            <label className="me-2 fw-bold"> Date: </label>
                            <div className="mob-w-100 ">
                                <select
                                    name="shrs"
                                    id="shr"
                                    className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                                    onChange={(e) => setDayFilter(e.target.value)}
                                    value={DayFilter}
                                >
                                    <option value="7">All</option>
                                  <option value="4">This Month</option>
                                    <option value="5">This Year</option>
                               </select>
                            </div>
                        </div> */}
                        {/* {customRange && <div className="gym-section w-100-mobile ms-2">
                            <label className="fw-bold">Custom Range</label>
                            <div className="d-flex align-items-center w-auto">
                                <input type="number" name="" id="" className="form-control w-80px" placeholder="From" value={range.from}
                                    onChange={(e) => setRange({
                                        ...range,
                                        from: e.target.value
                                    })} />

                                <div className="mx-2">-</div>
                                <input type="number" name="" id="" className="form-control w-80px " placeholder="To" value={range.to}
                                    onChange={(e) => setRange({
                                        ...range,
                                        to: e.target.value
                                    })} />
                            </div>
                        </div>} */}
                        {/* {customdate && <div className="gym-section w-100-mobile ms-3">
                            <span className="customRange align-items-center">
                                <label className="fw-bold">Custom Range</label>
                                <div className="gym-xlarge gym-larg-pos">
                                    <DatePicker
                                        dateFormat={"d/M/yyyy"}
                                        selectsRange={true}
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={(update) => {
                                            getDates(update)
                                        }}
                                        isClearable={false}
                                        customInput={<CalenderInput />}
                                    />
                                </div>
                            </span>
                        </div>} */}
                        <div className="gym-section w-100-mobile ms-3">
                            <div className="filterApplyMobile">
                                {/* <button
                                    type="submit"
                                    className="me-3 btn btn-primary"
                                    onClick={() => handleApplyAndToggle()}
                                >
                                    Apply
                                </button>
                                <button
                                    type="submit"
                                    className="mt-2 btn btn-secondary"
                                    onClick={() => { handleResetAndToggle() }}
                                >
                                    Clear
                                </button> */}
                                {(localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo")).role === "admin" && <button type="submit" className="ms-3 btnheight btn btn-primary"
                                    onClick={(e) => downloaddata(basicData, "Renew_Prediction")}
                                >
                                    <MDBIcon fas icon="download" className="d-inline me-1" />Export
                                </button>}
                                <MDBBtn className="ms-2" onClick={() => setGraphCheck(!graphCheck)}>{graphCheck ? <span><MDBIcon fas icon="table" className="me-1" />Table </span> : <span ><MDBIcon fas icon="chart-bar" className="me-1" />Graph</span>}</MDBBtn>
                            </div>
                        </div>
                    </div>

                    {/* <div className="">
                        {loading ? (
                            <div className="loader-height">
                                <Loader />
                            </div>
                        ) : (
                            <MDBDatatable
                                className=""
                                fixedHeader
                                maxHeight='calc(100vh - 223px)'
                                entries={25}
                                paging={true}
                                data={basicData}
                                tbodyProps={{
                                    style: {
                                        cursor: 'pointer'
                                    }
                                }}
                            />
                        )}
                    </div> */}
                    {!graphCheck && <div>
                        {loading ? (<div className="loader-height"> <Loader /></div>) : <><MDBDatatable className="sortOff trainerSummerySort" entries={25} paging={true} data={basicData} /></>}
                    </div>}

                    {graphCheck && <div className="w-100 border p-4 mb-4 shadow-4 mob-w-100 mob-p-0">
                        {loading ? (<div className="loader-height"> <Loader /></div>) : <>
                            {/* <RenewPredictionChart data={basicData.rows} /> */}
                            <LineReportChart
                                data={basicData.rows}
                                xField="date"
                                reverse={true}
                                datasetsConfig={[
                                    { field: "High chances", label: "High chances (100-80%)", color: "#4BC0C0", dashed: true },
                                    { field: "Medium chances", label: "Medium chances (79-50%)", color: "#FFCE56", dashed: true },
                                    { field: "Low chances", label: "Low chances (<50%)", color: "#FF6384", dashed: true },
                                    { field: "Renew Revenue", label: "Renew Revenue", color: "#36A2EB" },
                                    { field: "New Revenue", label: "New Revenue", color: "#9966FF" },
                                    { field: "Actual Revenue", label: "Actual Revenue", color: "#FF9F40", borderWidth: 4 }
                                ]}
                            />
                        </>}
                    </div>}
                </div>
            }

            <MDBModal staticBackdrop tabIndex='-1' open={openTogle} onClose={() => setOpenTogle(false)}>
                <MDBModalDialog size="lg">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                <h6 className="m-0">{memberName} Transaction Details</h6>
                            </MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => setOpenTogle(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody >
                            <div className="trainerMemberSummeryDataTable">
                                <MDBDatatable entries={25} data={basicData2} />
                            </div>
                        </MDBModalBody>
                        <MDBModalFooter className="pe-4 pb-3">
                            <MDBBtn className="ms-2" onClick={() => downloaddata(basicData2, "Renew_Predictioninfo")}>download</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}

export default RenewPrediction